export default {
  REQUEST_NOTIFICATIONS: 'notifications/REQUEST_NOTIFICATIONS',
  REQUEST_NOTIFICATIONS_SUCCESS: 'notifications/REQUEST_NOTIFICATIONS_SUCCESS',
  REQUEST_NOTIFICATIONS_FAILURE: 'notifications/REQUEST_NOTIFICATIONS_FAILURE',
  ADD_NOTIFICATION: 'notifications/ADD_NOTIFICATION',
  REMOVE_NOTIFICATION: 'notifications/REMOVE_NOTIFICATION',
  SET_USER: 'notifications/SET_USER',
};
